export const isEmptyArr = (arr) => {
  if (arr.length > 0) return false
  return true
}
